import { useMemo } from 'react'
import type { CircularCardProps } from './types'
import { mainClass, DEFAULT_LEVEL } from './constants'
import { getDefaultCircumference, calculateStrokeDashoffset } from './utils'
import { useIntersectionObserver, useAnimatedPercentage } from './hooks'
import { CircularProgress } from './CircularProgress'

import './index.scss'

export const CircularCardVariant = ({
  title,
  level = DEFAULT_LEVEL,
  percentage = 0,
  range,
}: CircularCardProps) => {
  const { isVisible, elementRef } = useIntersectionObserver()
  const currentPercentage = useAnimatedPercentage(percentage, isVisible)

  const circumference = useMemo(() => getDefaultCircumference(), [])
  const strokeDashoffset = useMemo(
    () => calculateStrokeDashoffset(circumference, currentPercentage),
    [circumference, currentPercentage]
  )

  return (
    <div ref={elementRef} className={mainClass}>
      <div className={`${mainClass}__level`}>{level}</div>

      <div className={`${mainClass}__circle-wrapper`}>
        <CircularProgress
          circumference={circumference}
            strokeDashoffset={strokeDashoffset}
          />

        <div className={`${mainClass}__percentage`}>
          <span className={`${mainClass}__number`}>{currentPercentage}%</span>
          {title && <span className={`${mainClass}__label`}>{title}</span>}
        </div>
      </div>

      {range && <div className={`${mainClass}__range`}>{range}</div>}
    </div>
  )
}
